import { render, staticRenderFns } from "./ProductionOrderCardMenu.vue?vue&type=template&id=471be8f0&"
import script from "./ProductionOrderCardMenu.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderCardMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports